export const TOGGLE_INTERIM_COLLAPSE_AMOUNT = 6;